<template>
  <div>
    <div class="dl_head">
      <div class="dl_head_tap">
        <div
          class="taps"
          v-for="(item, index) in taps"
          :key="index"
          :class="{ activetaps: item.active }"
          @click="changetaps(item.active)"
        >
          {{ item.text }}
          <div :class="{ activesanjiao: item.active }"></div>
        </div>
      </div>
    </div>
    <div class="dl_body" style="font-size: 14px">
      <p
        style="
          padding: 55px 0 0 0;
          text-align: left;
          width: 945px;
          margin: 0 auto;
          letter-spacing: 1px;
          line-height: 25px;
          color: #656565;
        "
        v-if="taps[0].active"
      >
        下载软件，通过模拟交易体验软件的功能。
      </p>
      <!-- <p
        style="
          padding: 55px 0 0 0;
          text-align: left;
          width: 945px;
          margin: 0 auto;
          letter-spacing: 1px;
          line-height: 25px;
          color: #656565;
        "
        v-if="taps[1].active"
      >
        下载软件，通过模拟交易体验软件的功能，交易账号需在“管理端”添加后，方可登录使用。
      </p> -->
      <div v-if="taps[0].active" class="zigdl">
        <div class="tap0left"></div>
        <div class="tap0right">
          <div class="rightpeiz">
            <p>使用应满足的条件</p>
            <p>1、CPU要达到四核及以上配置；</p>
            <p>2、win7/win2008的64位操作系统，4G内存；</p>
            <p>3、win10/win8的64位操作系统，8G内存；</p>
            <p>4、建议：使用电信、联通宽带，其它宽带会有卡顿问题。</p>
          </div>
          <div class="rightdl" style="position: relative">
            <div class="dianxdl" @click="dxdl">电信下载</div>
            <div class="liantdl" @click="ltdl">联通下载</div>
            <div style="margin-left: 20px; text-align: left">
              {{ gldbb }}<br />{{ glddx }}
            </div>
            <div
              class="czsc"
              style="
                padding: 15px 0 20px 0;
                position: absolute;
                left: 0;
                bottom: 0;
              "
            >
              <a
                href="https://ftpc.wenhua.com.cn/files/guide/whznjyglrj/管理端使用说明.pdf"
                target="_blank"
                >管理端使用说明</a
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a
                href="https://ftpc.wenhua.com.cn/files/guide/whznjyglrj/策略编写语法说明.pdf"
                target="_blank"
                >策略编写语法说明</a
              >
            </div>
            <div></div>
          </div>
          <div>
            <div
              class="tyzh"
              @click="changesmtap(true)"
              :class="{ activetyzh: smtap.s1 }"
            >
              注册体验账号
              <div class="huang" v-if="smtap.s1"></div>
            </div>
            <!-- <div
              class="tyzh"
              @click="changesmtap(false)"
              :class="{ activetyzh: smtap.s2 }"
            >
              找回体验账号密码
              <div class="huang" v-if="smtap.s2"></div>
            </div> -->
            <!-- <div class="tyzh" @click="gotomoni()">注册模拟资金账号</div> -->
          </div>
          <div>
            <div style="position: relative">
              <div v-if="smtap.s1" class="ipt">
                <div>体验账号自申请之日起3个月内有效</div>
                <form>
                  <div>
                    <span>*机构名称</span
                    ><input type="text" v-model.trim="jgmc"  ref="yzmcode"/>
                  </div>
                  <div>
                    <span>*姓名</span><input type="text" v-model.trim="name" />
                  </div>
                  <div>
                    <span>*手机号</span
                    ><input type="text" v-model.trim="phone" />
                  </div>
                  <div>
                    <span>*验证码</span
                    ><input
                      type="text"
                      style="width: 145px"
                      v-model.trim="code"
                    /><span
                      class="yzm"
                      @click="getzhcode"
                      :class="[iffa ? 'noclick' : '']"
                      >{{ yzm }}</span
                    >
                  </div>
                  <div class="queding" @click="tiyanzc">确认</div>
                </form>
              </div>
              <div v-if="smtap.s2" class="ipt">
                <div>
                  <span>注册手机号</span
                  ><input type="text" v-model.trim="zhphone" ref="yzmcode" />
                </div>
                <div>
                  <span>验证码</span
                  ><input
                    type="text"
                    style="width: 145px"
                    v-model.trim="zhcode"
                  /><span
                    class="yzm"
                    @click="getcode"
                    :class="[iffa1 ? 'noclick' : '']"
                    >{{ yzm1 }}</span
                  >
                </div>
                <div class="queding" @click="tiyanzh">确认</div>
              </div>

              <div id="sc" :class="{ check: !ischeck }"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-if="taps[1].active" class="kehu">
        <div class="tap1left"></div>
        <div class="tap0right">
          <div class="rightpeiz">
            <p>使用应满足的条件</p>
            <p>1、CPU要达到四核及以上配置；</p>
            <p>2、win7/win2008的64位操作系统，4G内存；</p>
            <p>3、win10/win8的64位操作系统，8G内存；</p>
            <p>4、建议：使用电信、联通宽带，其它宽带会有卡顿问题。</p>
          </div>
          <div class="rightdl" style="position: relative">
            <div class="dianxdl" @click="dxdlzd">电信下载</div>
            <div class="liantdl" @click="ltdlzd">联通下载</div>
            <div style="margin-left: 20px; text-align: left">
              {{ zdbb }}<br />{{ zddx }}
            </div>
            <div
              class="czsc"
              style="
                padding: 15px 0 20px 0;
                position: absolute;
                left: 0;
                bottom: 0;
              "
            >
              <a
                href="https://ftpc.wenhua.com.cn/files/guide/whznjyglrj/用户使用端说明.pdf"
                target="_blank"
                >用户使用端说明</a
              >
            </div>
          </div>
          <div class="tyzh" @click="gotomoni()">注册模拟资金账号</div>
        </div>
      </div> -->
      <!-- <div class="zhedang" v-if="ifshowzd">
        <div class="baikuang" v-if="ifshowmm">
          <div @click="close" class="close">x</div>
          <div class="tktitle">{{ ifshowmmtit }}</div>
          <div>管理端登录账号：{{ jgzh }}</div>
          <div>
            密码：{{ jgmm }}
            <div class="xhmm" @click="xgmm()">修改密码</div>
          </div>
        </div>
        <div class="baikuang" v-if="ifshowxg">
          <div @click="close" class="close">x</div>
          <div class="tktitle">修改密码</div>
          <div><span>管理端登录账号</span>{{ jgzh }}</div>
          <div>
            <span>新密码</span
            ><input
              type="password"
              v-model="newpwd"
              placeholder="请输入新密码"
            />
          </div>
          <div>
            <span>确认新密码</span
            ><input
              type="password"
              v-model="dbnewpwd"
              placeholder="请再次输入新密码"
            />
          </div>
          <div
            style="
              text-align: center;
              height: 60px;
              line-height: 60px;
              margin-bottom: 20px;
            "
          >
            <p @click="xiugaimm" class="xgbtn">修改</p>
            <p @click="fanhui" class="fhbtn">返回</p>
          </div>
        </div>
        <div class="modal2" v-if="ifshowld">
          <div class="loading">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div> -->
    </div>
    <box :message="message" @showbox="showboxx" v-if="showbox"></box>
  </div>
</template>
<script>
import axios from "axios";
import commonData from '../plugins/FetchCommonData'
import qs from "qs";
import box from "../components/box.vue";
export default {
  components: { box },
  data() {
    return {
      iffa: false, //判断两个验证码点击是否生效
      iffa1: false,
      yzm1: "获取验证码", //两个验证码文字
      yzm: "获取验证码",
      newzh: "", //页面文字
      newpwd: "",
      dbnewpwd: "",
      jgzh: "",
      jgmm: "",
      ic: null, //智能验证
      ischeck: false, //是否显示验证
      ifshowzd: false, //是否显示遮挡
      ifshowmm: false, //是否显示账号密码白框
      ifshowxg: false, //是否显示修改密码白框
      ifshowld: false, //是否显示loading
      name: "", //参数
      zhphone: "",
      zhcode: "",
      jgmc: "",
      phone: "",
      code: "",
      sessionid: "",
      token: "",
      sig: "",
      showyzm: false, //判断是发的那个验证码
      showyzm1: false,
      set: null, //两个60秒的读秒轮询
      set1: null,
      ifshowmmtit: "注册成功！",
      act: true,
      taps: [
        {
          text: "管理端",
          active: "",
        },
        // {
        //   text: "用户使用端",
        //   active: "",
        // },
      ],
      smtap: {
        //申请体验账号和找回体验账号的切换
        s1: false,
        s2: false,
      },
      dxdlurl: "", //管理端电信下载地址
      ltdlurl: "", //管理端联通下载地址
      dxdlzdurl: "", //终端电信下载地址
      ltdlzdurl: "", //终端联通下载地址
      gldbb: "加载中...", //管理端版本
      glddx: "加载中...", //管理端大小
      zdbb: "加载中...", //终端版本
      zddx: "加载中...", //终端大小
      message: "",
      showbox: false,
    };
  },
  methods: {
    showboxx(showbox) {
      this.showbox = showbox;
    },
    xiugaimm() {
      //注册完账号后的修改密码页面接口
      if (this.newpwd == this.dbnewpwd) {
        var formMess = {
          RasysUsername: this.jgzh,
          RasysPassword: this.jgmm,
          NewPassword: this.newpwd,
        };
        axios
          .post(
            "https://www.wenhua.com.cn/api/DataApi/ZntgUpdate",
            qs.stringify(formMess),
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          )
          .then((res) => {
            if (res.data.status) {
              this.close();
            }
            // alert(res.data.msg);
            this.message = res.data.msg;
            this.showbox = true;
          });
      } else {
        // alert("两次密码输入不一致");
        this.message = "两次密码输入不一致";
        this.showbox = true;
      }
    },
    dxdl() {
      //电信联通下载
      if (this.dxdlurl != "") {
        window.location.href = this.dxdlurl;
      }
    },
    ltdl() {
      if (this.ltdlurl != "") {
        window.location.href = this.ltdlurl;
      }
    },
    dxdlzd() {
      //终端的下载
      if (this.dxdlzdurl != "") {
        window.location.href = this.dxdlzdurl;
      }
    },
    ltdlzd() {
      if (this.ltdlzdurl != "") {
        window.location.href = this.ltdlzdurl;
      }
    },
    fanhui() {
      //修改密码返回到注册或者找回
      this.ifshowmm = true;
      this.ifshowxg = false;
      this.ifshowld = false;
    },
    shanchu() {
      var formMess = {
        MobileNumber: "18742593065",
      };
      axios
        .post(
          "https://www.wenhua.com.cn/api/DataApi/ZntgDel",
          qs.stringify(formMess),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          console.log(res);
        });
    },
    gotomoni() {
      //跳转到模拟账号注册
      window.open(
        "https://www.wenhua.com.cn/Home/SimulationTradeRegistor",
        "_blank"
      );
    },
    close() {
      //关闭
      (this.newpwd = ""), (this.dbnewpwd = ""), (this.iffa = false);
      this.iffa1 = false;
      this.ifshowzd = false;
      this.ifshowmm = false;
      this.ifshowxg = false;
      this.ifshowld = false;
      clearInterval(this.set);
      clearInterval(this.set1);
      this.yzm1 = "获取验证码";
      this.yzm = "获取验证码";
      this.ifshowmmtit = "注册成功！";
    },
    xgmm() {
      //打开修改密码界面
      this.ifshowmm = false;
      this.ifshowxg = true;
    },
    tiyanzc() {
      //体验账号注册结果
      var formMess = {
        Username: this.name,
        MobileNumber: this.phone,
        Code: this.code,
        OrganizationName: this.jgmc,
      };
      this.ifshowzd = true;
      this.ifshowld = true;
      axios
        .post(
          "https://www.wenhua.com.cn/api/DataApi/ZntgAdd",
          qs.stringify(formMess),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          // console.log(res);
          this.ifshowld = false;
          if (res.data.status) {
            if (res.data.msg == "注册成功！") {
              this.ifshowmm = true;

              this.jgzh = res.data.data.strRasysUserName;
              this.jgmm = res.data.data.strRasysPassWord;
            } else {
              this.ifshowzd = true;
              this.jgzh = res.data.data.strRasysUserName;
              this.jgmm = res.data.data.strRasysPassWord;
              this.ifshowmm = true;
              this.ifshowmmtit = "该手机号已注册！";
            }
          } else {
            this.ifshowzd = false;
            // alert(res.data.msg);
            this.message = res.data.msg;
            this.showbox = true;
          }
        })
        .catch(function (error) {
          console.log(error);
          this.ifshowzd = false;
        });
    },
    tiyanzh() {
      //账号找回
      var formMess = {
        MobileNumber: this.zhphone,
        Code: this.zhcode,
      };
      axios
        .post(
          "https://www.wenhua.com.cn/api/DataApi/ZntgFind",
          qs.stringify(formMess),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          // console.log(res);
          if (res.data.status) {
            if (res.data.msg == "注册成功！") {
              this.ifshowmm = true;

              this.jgzh = res.data.data.strRasysUserName;
              this.jgmm = res.data.data.strRasysPassWord;
            } else {
              this.ifshowzd = true;
              this.jgzh = res.data.data.strRasysUserName;
              this.jgmm = res.data.data.strRasysPassWord;
              this.ifshowmm = true;
              this.ifshowmmtit = "找回账号！";
            }
          } else {
            this.ifshowzd = false;
            // alert(res.data.msg);
            this.message = res.data.msg;
            this.showbox = true;
          }
        })
        .catch(function (error) {
          console.log(error);
          this.ifshowzd = false;
        });
    },
    getcode() {
      //找回获取验证码的操作
      if (this.iffa1 == false) {
        this.ischeck = true;
        this.showyzm1 = true;
      }
    },
    getzhcode() {
      //注册获取验证码的操作
      if (this.iffa == false) {
        this.ischeck = true;
        this.showyzm = true;
      }
    },
    setcheck() {
      //智能验证重置
      (this.ischeck = false), this.icreset();
    },
    changetaps(it) {
      //切换两个下载界面
      if (it == false) {
        this.act = !this.act;
        this.taps[0].active = this.act;
        this.taps[1].active = !this.act;
      }
    },
    changesmtap(sta) {
      this.showbox=true
      //切换两个注册找回界面
      // this.ischeck = false;
      // if (sta) {
      //   if (this.smtap.s1 == true) {
      //     this.smtap.s1 = false;
      //     this.smtap.s2 = false;
      //   } else {
      //     this.smtap.s1 = true;
      //     this.smtap.s2 = false;
      //   }
      // } else {
      //   if (this.smtap.s2 == true) {
      //     this.smtap.s1 = false;
      //     this.smtap.s2 = false;
      //   } else {
      //     this.smtap.s1 = false;
      //     this.smtap.s2 = true;
      //   }
      // }
    },
    goto(url) {
      window.open(url, "_blank");
    },
    icreset(){
       let _this = this;
        window.initAliyunCaptcha({
          
            // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
            SceneId: "17lat2dd",// H5场景：1ppoxyts  Web场景：17lat2dd
            // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
            mode: "embed",
            // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
            element: "#sc",
            // 触发验证码弹窗或无痕验证的元素
            // button: "#sc",
            // 验证码验证通过回调函数
            success: function (captchaVerifyParam) {
            if (_this.showyzm1 == true) {

              _this.token = captchaVerifyParam;
              // if(this.tel==''){

              // }
              var formMess = {
                phone: _this.zhphone,
                token: _this.token,
                sence:0,
              };
              axios
                .post(
                  "https://www.wenhua.com.cn/api/DataApi/GetMobileCode",
                  qs.stringify(formMess),
                  {
                    headers: {
                      "Content-Type": "application/x-www-form-urlencoded",
                    },
                  }
                )
                .then((res) => {
                  _this.showyzm1 = false;
                  if (res.data.status) {
                    _this.iffa1 = true;
                    var time1 = 60;
                    _this.yzm1 = "重新发送(" + time1 + ")";
                    _this.set = setInterval(() => {
                      if (time1 > 0) {
                        _this.yzm1 = "重新发送(" + time1 + ")";
                        time1--;
                      } else {
                        _this.yzm1 = "重新发送";
                        _this.iffa1 = false;
                        clearInterval(_this.set);
                      }
                    }, 1000);
                  }
                  // alert("验证码已发送");
                  if (res.data.status) {
                    _this.message = "验证码已发送";
                  } else {
                    _this.message = res.data.msg;
                  }
                  _this.showbox = true;
                  _this.setcheck();
                });
            } else if (_this.showyzm == true) {

              
              _this.token = captchaVerifyParam;
              // if(this.tel==''){

              // }
              var formMesss = {
                phone: _this.phone,
                token: _this.token,
                zhlx: 9,
                sence:0,
              };
              axios
                .post(
                  "https://www.wenhua.com.cn/api/DataApi/GetMobileCode",
                  qs.stringify(formMesss),
                  {
                    headers: {
                      "Content-Type": "application/x-www-form-urlencoded",
                    },
                  }
                )
                .then((res) => {
                  // console.log(res);
                  _this.showyzm = false;
                  if (res.data.status) {
                    _this.iffa = true;
                    var time = 60;
                    _this.yzm = "重新发送(" + time + ")";
                    _this.set1 = setInterval(() => {
                      if (time > 0) {
                        _this.yzm = "重新发送(" + time + ")";
                        time--;
                      } else {
                        _this.yzm = "重新发送";
                        _this.iffa = false;
                        clearInterval(_this.set1);
                      }
                    }, 1000);
                  }
                  // alert("验证码已发送");
                  if (res.data.status) {
                    _this.message = "验证码已发送";
                  } else {
                    _this.message = res.data.msg;
                  }
                  _this.showbox = true;
                  _this.setcheck();
                });
            }
          },
          fail: function (result) {
                // 入参为不通过信息
                // 正常验证有效期内不需要做任何操作，验证码自动刷新，重新进行验证
                console.error(result);
                // alert(result.verifyCode)
            },
            // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
            getInstance: function (instance) {
                _this.ic=instance
            },
            // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。兼容历史参数名。
            slideStyle: {
                width: 259,
                height: 42,
            },
            // width最小为320px，传入小于320数值将按320处理。
            // 若移动端部分机型上出现滑块宽度超过屏幕，可通过整体缩放功能解决
            rem: 0.83
            // ...其他参数，参考initAliyunCaptcha参数说明
          });
    }
  },
  created() {
    this.taps[0].active = this.act;
    
    
    axios.get("https://webapi.wenhua.com.cn/update/api/Update/GetUpdateInfo?appid=32").then((res) => {
      console.log(res)
      if (res.data.Status) {
        this.dxdlurl  = 'https://ftpc.wenhua.com.cn/files/WHRA/WHRAMgr_Semi_Beta.exe';
        this.ltdlurl = 'https://ftpc1.wenhua.com.cn/files/WHRA/WHRAMgr_Semi_Beta.exe';
        var data=JSON.parse(res.data.ResultData)
        console.log(data)
        this.gldbb= "版本："+data.UpdateTime_beta
;
        this.glddx =
          "大小：" +
         data.Size_beta+
          " 日期：" +
        data.UpdateTime_beta
;
        console.log(res.data)

      }
    });
    commonData('serviceTel').then((res)=>{
      this.message = '请拨打'+ res +'咨询注册'
    })
    // this.taps[1].active = !this.act;
    // axios
    //   .post(
    //     "https://webapi.wenhua.com.cn/update/api/Update/UpdateGet?appid=25&ver=0"
    //   )
    //   .then((res) => {
    //     this.dxdlzdurl = res.data.ResultData.Package;
    //     this.ltdlzdurl = res.data.ResultData.Package_;
    //     this.zdbb = "版本：" + res.data.ResultData.Version;
    //     this.zddx =
    //       "大小：" +
    //       res.data.ResultData.Size +
    //       " 日期：" +
    //       res.data.ResultData.UpdateDate;
    //   });
    // axios
    //   .post(
    //     "https://webapi.wenhua.com.cn/update/api/Update/UpdateGet?appid=24&ver=0"
    //   )
    //   .then((res) => {
    //     this.dxdlurl = res.data.ResultData.Package;
    //     this.ltdlurl = res.data.ResultData.Package_;
    //     this.gldbb = "版本：" + res.data.ResultData.Version;
    //     this.glddx =
    //       "大小：" +
    //       res.data.ResultData.Size +
    //       " 日期：" +
    //       res.data.ResultData.UpdateDate;
    //   });
  },
  mounted() {
   this.icreset()
   
  },
};
</script>
<style scoped>
input {
  padding-left: 5px;
}
.xgbtn {
  width: 100px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background-color: rgb(68, 141, 243);
  border-radius: 3px;
  border: none;
  color: rgb(255, 255, 255);
  letter-spacing: 2px;
  margin-left: 60px !important;
}
.fhbtn {
  text-decoration: underline;
  height: 28px;
  line-height: 28px;
}
.noclick {
  cursor: not-allowed !important;
}
.zhedang {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 3333;
}
.baikuang {
  background: white;
  min-height: 220px;
  width: 550px;
  position: fixed;
  top: 20%;
  left: 40%;
  text-align: center;
  border-radius: 5px;
  font-size: 15px;
}
.baikuang input {
  width: 196px;
  height: 28px;
  line-height: 28px;
  border: 1px solid rgb(137, 137, 137);
  color: rgb(121, 121, 121);
  font-size: 15px;
  padding: 0px 10px;
}
.baikuang div span {
  display: inline-block;
  width: 150px;
  text-align: right;
  margin-right: 10px;
}
.xhmm {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
  width: 100px !important;
  display: inline-block;
}
.close {
  width: 6px !important;
  font-size: 12px;
  text-align: right !important;
  position: absolute;
  right: 10px;
  top: -6px;
  cursor: pointer;
}
.tktitle {
  margin-top: 30px !important;
  font-size: 18px;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #848484;
  margin-bottom: 15px;
}
.baikuang div {
  width: 400px;
  margin: 0 auto;
  text-align: left;
  line-height: 38px;
}
.baikuang div p {
  cursor: pointer;
  display: inline-block;
  margin: 0 5px;
}
.check {
  visibility: hidden;
}
#sc {
  margin: 0;
  position: absolute;
  bottom: 40px;
  z-index: 11111;
  left: 86px;
}
.ipt {
  margin-top: 58px;
  text-align: left;
  margin-left: 20px;
  color: #848484;
}
.ipt div {
  line-height: 35px;
}
.ipt input {
  width: 250px;
  height: 25px;
  border: 1px solid #d9d9d9;
}
.queding {
  background: #ebb263;
  color: white;
  height: 30px;
  line-height: 30px !important;
  text-align: center;
  width: 120px;
  border-radius: 12px;
  font-size: 16px;
  margin: 18px 120px;
  cursor: pointer;
}
.yzm {
  color: #3d7bdd;
  width: 100px !important;
  margin: 0 10px;
  cursor: pointer;
}
.ipt span {
  display: inline-block;
  width: 80px;
  margin-right: 15px;
  text-align: right;
  letter-spacing: 2px;
}
.huang {
  border-top: 6px #ebb263 solid;
  border-left: 6px #ffffff solid;
  border-right: 6px #ffffff solid;
  position: absolute;
  bottom: -8px;
  left: 47%;
}
.tyzh {
  color: #4e6abf;
  border-bottom: 2px solid #4e6abf;
  float: left;
  margin: 0 20px;
  cursor: pointer;
  position: relative;
}
.activetyzh {
  color: #ebb263;
  border-bottom: 2px solid #ebb263;
}
.rightdl div {
  float: left;
  text-align: center;
}
.rightdl {
  height: 100px;
  margin-left: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  border-bottom: 1px gray dashed;
}
.dianxdl {
  background: #e8a452;
  color: white;
  height: 39px;
  line-height: 39px;
  width: 130px;
  border-radius: 8px;
  font-size: 16px;
  user-select: none;
  cursor: pointer;
}
.liantdl {
  margin-left: 20px;
  background: #d09143;
  color: white;
  height: 39px;
  line-height: 39px;
  width: 130px;
  border-radius: 8px;
  font-size: 16px;
  user-select: none;
  cursor: pointer;
}
.tap0left {
  /* float: left; */
  display: inline-block;
  vertical-align: top;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=103) no-repeat right 26px;
  width: 539px;
  height: 371px;
}
.tap1left {
  /* float: left; */
  display: inline-block;
  vertical-align: top;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=104) no-repeat right 26px;
  width: 539px;
  height: 371px;
}
.tap0left p {
  color: #656565;
  padding-top: 30px;
  text-align: left;
  padding-left: 85px;
}
.tap1left p {
  color: #656565;
  padding-top: 30px;
  text-align: left;
  padding-left: 85px;
}
.tap0right {
  width: 575px;
  display: inline-block;
  /* float: left; */
  height: 100%;
  color: #656565;
}
.rightpeiz {
  text-align: left;
  padding: 26px 0 0 20px;
  line-height: 30px;
  letter-spacing: 1px;
  font-size: 14px;
}
.dl_head {
  height: 275px;
  background: url(../assets/img/gn-banner.jpg) no-repeat center;
  border-bottom: 4px solid #0a3b95;
  position: relative;
}
.dl_body {
  min-height: 425px;
  background: url(../assets/img/xz-bg.jpg) no-repeat top;
  /* background: url(../assets/img/bg-dl.jpg) no-repeat center; */
  background-size: 1920px 676px;
}
.dl_head_tap {
  width: 1054px;
  height: 61px;
  margin: 0 auto;
  padding-top: 214px;
}
.taps {
  height: 100%;
  width: 523px;
  margin: 0 2px;
  border-radius: 5px 5px 0 0;
  text-align: center;
  line-height: 61px;
  background: #e6e6e6;
  position: relative;
  display: inline-block;
  color: #113f8a;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  letter-spacing: 2px;
}
.activetaps {
  background: url(../assets/img/qh-1.png) no-repeat center;
  color: #fffffb;
}
.activesanjiao {
  width: 15px;
  height: 15px;

  position: absolute;
  background: url(../assets/img/sanjiao.png) no-repeat center;
  bottom: -13px;
  z-index: 999;
  left: 263px;
}
.zigdl {
  width: 1145px;
  margin: 0 auto;
  /* margin-top: 0; */
  height: 100%;
  font-size: 14px;
  /* height: 635px; */
  min-height: 463px;
}
.kehu {
  width: 1145px;
  margin: 0 auto;
  min-height: 463px;
  color: #656565;
}
.dl_gw {
  border-bottom: 1px #bbbbbb dashed;
  padding: 20px 0;
  min-height: 80px;
  vertical-align: top;
}
.dl_gw:last-child {
  border: none;
}
.gw_left {
  width: 90px;
  padding-right: 20px;
  height: 80px;
  display: inline-block;
  vertical-align: top;
}
.gw_mid {
  display: inline-block;
  height: 100%;
  width: 700px;
  text-align: left;
  vertical-align: top;
}
.gw_right {
  width: 85px;
  padding: 0 20px;
  display: inline-block;
  height: 100%;
  vertical-align: top;
}
.title {
  font-size: 16px;
  display: inline-block;
  color: #505050;
  width: 200px;
  font-weight: bold;
}
.banben {
  font-size: 12px;
  color: #adadad;
  display: inline-block;
  margin-left: 120px;
  vertical-align: top;
}
.djdl {
  border: 1px #cfc9fb solid;
  background: #d1dffa;
  height: 28px;
  line-height: 28px;
  text-align: center;
  width: 100%;
  color: #173b69;
  cursor: pointer;
}
/* ----------------loading ----------------*/
.modal2 {
  position: absolute;
  width: 300px;
  height: 400px;
  left: 50%;
  top: 35%;
  transform: translate(-50%, -50%);
  /* background-color:#fff; */
  display: block;
  /* cursor: pointer; */
  z-index: 9000;
  text-align: center;
  padding: 20px;
}

.modal2 .loading {
  width: 150px;
  height: 15px;
  margin: 0 auto;
  margin-top: 100px;
}
.modal2 .loading span {
  display: inline-block;
  width: 15px;
  height: 100%;
  margin-right: 5px;
  border-radius: 50%;
  background: #fff;
  -webkit-animation: load 1.04s ease infinite;
}
.modal2 .loading span:last-child {
  margin-right: 0px;
}
@-webkit-keyframes load {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.modal2 .loading span:nth-child(1) {
  -webkit-animation-delay: 0.13s;
}
.modal2 .loading span:nth-child(2) {
  -webkit-animation-delay: 0.26s;
}
.modal2 .loading span:nth-child(3) {
  -webkit-animation-delay: 0.39s;
}
.modal2 .loading span:nth-child(4) {
  -webkit-animation-delay: 0.52s;
}
.modal2 .loading span:nth-child(5) {
  -webkit-animation-delay: 0.65s;
}

.modal img {
  display: block;
  margin: 40px auto 0px auto;
}
.czsc {
  line-height: 25px;
}
.czsc a {
  color: #a0896d;
  text-decoration: underline;
}
.czsc a:visited {
  color: #a0896d;
}
</style>